import { Box, Image, Pressable, Text, VStack } from 'native-base'
import { isMobile } from 'react-device-detect'

import i18n from '../i18n'
import { trackEvent } from '../utils/analytics-v2'

const Support = ({
  showMobile,
  maxWidth,
  maxHeight,
  height,
}: {
  showMobile: boolean
  maxWidth?: string
  maxHeight?: string
  height?: string
}) => {
  const handleLinkClick = () => {
    trackEvent('contact_support', { method: 'sms' })
    window.location.href = `sms:68953`
  }

  const UpdatedSupportButton = () => (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: 20,
        borderColor: '#E8E8E8',
        borderWidth: 1,
        padding: 24,
        backgroundColor: 'white',
      }}
      borderRadius={'24px'}
      maxWidth={maxWidth}
      maxH={maxHeight}
      height={height}
    >
      <Image
        source={{
          uri: 'support.svg',
        }}
        resizeMode="contain"
        alt={i18n.t('common:SUPPORT')}
        size="md"
        mr={'32px'}
      />
      <VStack display={'flex'} alignItems={'flex-start'} flex={1}>
        <Text fontFamily={'bodyBold'} style={{ fontSize: 14, marginBottom: 4 }}>
          Need help?
        </Text>
        <Text marginBottom={2.5} style={{ fontSize: 14 }}>
          Text us at 68953 to connect with a support agent.
        </Text>
        <Pressable id="contact-support" onPress={() => handleLinkClick()}>
          <Box
            paddingX="16px"
            paddingY="6px"
            bg="black"
            rounded="lg"
            borderRadius={100}
            _text={{
              color: 'white',
              fontWeight: '600',
              fontSize: '14px',
            }}
          >
            Text Support
          </Box>
        </Pressable>
      </VStack>
    </Box>
  )

  return (
    <>
      {isMobile || showMobile ? (
        <Pressable onPress={() => handleLinkClick()} id="contact-support">
          <UpdatedSupportButton />
        </Pressable>
      ) : (
        <UpdatedSupportButton />
      )}
    </>
  )
}

export default Support
